import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImmigrationApi, ImmigrationProfile, ImmigrationProfileMiletones } from 'src/app/core/api.gen';
import { LoaderService } from 'src/app/core/loader.service';

@Component({
  selector: 'eos-milestone',
  templateUrl: './milestone.component.html',
  styleUrls: ['./milestone.component.css']
})
export class MilestoneComponent implements OnInit {
  @Input() id: number;
  @Input() country: string;
  flag =  false;

  visaname : string;
  candidatename : string;
  mileStone: ImmigrationProfileMiletones[] = [];

  constructor(public modal: NgbActiveModal, private immigrationApi: ImmigrationApi, private loader: LoaderService,
    private activeRoute: ActivatedRoute) { }

  ngOnInit() {
    
    if(this.id == null && this.country == null){
      this.activeRoute.params.subscribe(routeParams => {
        if (routeParams.id && routeParams.id > 0) {
          this.id = routeParams.id;
          this.country = routeParams.country;
          this.flag=true;
        }
      });
    }

  this.loader.show();
  this.immigrationApi.getImmigrationInfoMin(this.id).subscribe(res => {
    this.visaname = res.visatypeName 
    this.candidatename=res.candidateName 

  });

    this.immigrationApi.getRequestMileStones(this.id, this.country)
      .subscribe(resp => {
        this.loader.clear();
       
        resp.forEach(x=>x.milestoneTimeline=Number(Math.fround(x.milestoneTimeline/24).toFixed(2)))

        this.mileStone = resp;
   
      },
      error => {
        this.loader.clear();
      });


  }
 

legendStyle(satusId: number) {
    switch (satusId) {

      case 0: {
        return " timeline Not-Started"

      }
      case 1 : {
        return " timeline In-Progress"
      }
      case 2 : {
        return "timeline Not-Applicable"
      }
      case 3 : {
        return "timeline Completed"
      }
    }
  }

}
